import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import { useState} from "react";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { useNavigate, useLocation } from "react-router-dom";
import { ProductService } from "../../../services/ProductService.js";
import { createListaEspera } from "../../../services/ListaEsperaService.js";

const productService = new ProductService();

function FormCrearListaEspera({
    visible,
    onHide,
    idCliente,
    tiposProducto,
    setDisplayDialog,
    setTiposProducto,
    baseUrl,
}) {
    const navigate = useNavigate();
    const location = useLocation();
    const idCotizacion = new URLSearchParams(location.search).get("idCotizacion");
    // Empresas disponibles
    const empresasOptions = [
        { label: 'ALTAMIRA', value: 'ALTAMIRA' },
        { label: 'LA SIEMBRA', value: 'LA SIEMBRA' },
        { label: 'TODAS', value: 'TODAS' }
    ];
    const idUsuario = sessionStorage.getItem("usuario_id");
    const [idTipoProducto, setIdTipoProducto] = useState([]);
    const [metrajeRequerido, setMetrajeRequerido] = useState(0);
    const [loading, setLoading] = useState(false);
    const [tipoProducto, setTipoProducto] = useState([]);
    const [empresa, setEmpresa] = useState("");
    const [tipoProductoTouched, setTipoProductoTouched] = useState(false);
    const [empresaTouched, setEmpresaTouched] = useState(false);

    const getTipoProductoByEmpresa = async (empresa) => {
        try {
        const tipos = await productService.getTiposProductoByEmpresa(baseUrl, empresa);
        if (Array.isArray(tipos)) {
            setTiposProducto(tipos);
        }
        } catch (error) {
        console.error(error);
        }
    };

    //CREAR LISTA DE ESPERA
    const validateInputs = () => {
        if (!metrajeRequerido || !idTipoProducto || !empresa) {
        alert("Todos los campos son obligatorios.");
        return false;
        }
        return true;
    };

    const handleCreateListaEspera = async () => {
        setLoading(true);

        if (!validateInputs()) {
            return;
        }
        try{
        
        const newListaEspera = {
            empresa: empresa,
            idCliente: idCliente,
            idTipoProducto: idTipoProducto,
            metrajeRequerido: metrajeRequerido,
            idUsuario: idUsuario,
            idCotizacion: idCotizacion || null,
        };
        //console.log(newListaEspera);
        // Esperar el resultado y obtener el ID de la lista de espera creada
        const insertedListaEspera = await createListaEsperaAPI(newListaEspera);

        return insertedListaEspera
        }catch (error) {
        console.error("Error al crear lista de espera:", error);
        alert(error.message || "Error al crear lista de espera");
        setLoading(false);
        return null;
        }finally{
            setLoading(false);
            setDisplayDialog(false);
            let newUrl = `/listaEspera`;
            navigate(newUrl);
        }
    };

    const createListaEsperaAPI = async ({
        empresa,
        idCliente,
        idTipoProducto,
        metrajeRequerido,
        idUsuario,
        idCotizacion
    }) => {
        try {
        return await createListaEspera(baseUrl, {
            empresa,
            idCliente,
            idTipoProducto,
            metrajeRequerido,
            idUsuario,
            idCotizacion
        });
        } catch (error) {
            console.error("Error al crear lista de espera:", error);
            alert(error.message || "Error al crear lista de espera");
        }
    };

    return (
        <Dialog
            header="Crear Solicitud de Lista de Espera"
            visible={visible}
            onHide={onHide}
            className="p-fluid product-dialog"
            modal
            footer={
                <div className="flex justify-content-end">
                    <Button
                        label="Cancelar"
                        icon="pi pi-times"
                        className="p-button-rounded p-button-outlined mr-2 p-button"
                        onClick={onHide}
                        raised
                    />
                    <Button
                        label="Enviar"
                        icon={loading ? "pi pi-spin pi-spinner" : "pi pi-send"}
                        className="p-button-success p-button-rounded p-button"
                        loading={loading}
                        onClick={handleCreateListaEspera}
                        raised
                    />
                </div>
            }
        >
            
            <div className="field">
                <span className="p-float-label mt-2 mb-3">
                    
                    <Dropdown
                        value={empresa}
                        options={empresasOptions}
                        onChange={async (e) => {
                        setEmpresa(e.value);
                        setTipoProducto("");
                        setTipoProductoTouched(true);
                        await getTipoProductoByEmpresa(e.value);
                        }}
                        placeholder="Seleccione Empresa"
                        required
                        className={empresaTouched && (!empresa || empresa.length === 0) ? 'p-invalid' : ''}
                        onBlur={() => setEmpresaTouched(true)}
                    />
                    {empresaTouched && (!empresa || empresa.length === 0) && (
                        <small className="p-error">La empresa es obligatoria</small>
                    )}
                    <label>Empresa *</label>
                </span>
            </div>

            <div className="field">
                <span className="p-float-label mt-2 mb-3">
                    <MultiSelect
                        value={tipoProducto}
                        onChange={(e) => {
                        setTipoProducto(e.value);
                        setTipoProductoTouched(true);
                        const ids = (e.value || []).map((opt) => opt.id);
                        setIdTipoProducto(ids.join(",")); // setea IDs separados por comas
                        }}
                        onBlur={() => setTipoProductoTouched(true)}
                        options={tiposProducto
                        // .filter((option, index, self) =>
                        //     index === self.findIndex((t) => t.descripcion === option.descripcion)
                        // )
                        .map((option) => ({
                            ...option,
                            label: option.descripcion + " - " + option.nombre_empresa, 
                        }))
                        }
                        optionLabel="label"
                        placeholder="Seleccione Tipo Producto"
                        filter
                        required
                        className={tipoProductoTouched && (!tipoProducto || tipoProducto.length === 0) ? 'p-invalid' : ''}
                    />
                    {tipoProductoTouched && (!tipoProducto || tipoProducto.length === 0) && (
                        <small className="p-error">El tipo de producto es obligatorio</small>
                    )}
                    <label>Tipo Producto *</label>
                </span>
            </div>
            
            <div className="field">
                <span className="p-float-label mt-2 mb-3">
                    <InputNumber
                        value={metrajeRequerido}
                        onChange={(e) => setMetrajeRequerido(e.value)}
                        placeholder="ej: 70"
                        useGrouping={false}
                        min={1}
                    />
                    <label htmlFor="metrejeRequerido">
                        <i className="pi pi-tag mr-2"></i>Metraje Requerido *
                    </label>
                </span>
            </div>
            
        </Dialog>
    );
}

export default FormCrearListaEspera;